import {
  Approval,
  UpdateApprovalPayload,
  CreateApprovalPayload,
} from 'api/approval';
import { TaskStatusType } from 'api/status-updates';
import { HttpClient } from '../http-client';

class TaskApprovalHttpClient extends HttpClient {
  public async getApprovalList(
    projectId: number,
    taskId: number,
  ): Promise<Approval[]> {
    return this.get<Approval[]>(
      `/projects/${projectId}/tasks/${taskId}/approvals`,
    );
  }

  public async getApproval(
    projectId: number,
    type: TaskStatusType,
    dates: [number, number],
  ): Promise<Approval[]> {
    return this.get<Approval[]>(
      `/projects/${projectId}/approvals?filterType=${type}&startDate=${dates[0]}&endDate=${dates[1]}`,
    );
  }

  public async updateApproval(
    projectId,
    taskId,
    approvalId,
    payload: UpdateApprovalPayload,
  ): Promise<Approval> {
    return this.put(
      `projects/${projectId}/tasks/${taskId}/approvals/${approvalId}`,
      payload,
    );
  }

  public async createApproval(
    projectId,
    taskId,
    payload: CreateApprovalPayload,
  ): Promise<Approval> {
    return this.post(
      `projects/${projectId}/tasks/${taskId}/approvals`,
      payload,
    );
  }

  public async deleteApproval(projectId, taskId, approvalId): Promise<void> {
    return this.delete(
      `projects/${projectId}/tasks/${taskId}/approvals/${approvalId}`,
    );
  }

  public async getApprovals({
    projectId,
    taskId,
  }: {
    projectId: number;
    taskId: number;
  }): Promise<Approval[]> {
    return this.get(`projects/${projectId}/tasks/${taskId}/approvals`);
  }
}

export const TaskApprovalAPI = new TaskApprovalHttpClient();
